import { render, staticRenderFns } from "./Confirmar.vue?vue&type=template&id=04a08e1e"
import script from "./Confirmar.vue?vue&type=script&lang=ts"
export * from "./Confirmar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports